const SvgArrowDownIcon = ({
  className = '',
  stroke = '#F04438',
  strokeWidth = '2',
  viewBox = '0 0 15 14',
  d = 'M7.33333 1.16669V12.8334M7.33333 12.8334L13.1667 7.00002M7.33333 12.8334L1.5 7.00002',
}) => {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      className={className}
      viewBox={viewBox}
      stroke={stroke}
      strokeWidth={strokeWidth}
    >
      <path d={d} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default SvgArrowDownIcon
